module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kpokO"))).then(() => parcelRequire('d0iPb'));